import axios from 'axios'
import type { TFACurtailmentInterval, ITFACurtailmentIntervalCreationPayload, ICurtailmentRatio } from '@/types/cpm'
import type { IPage } from '@/types/shared/pagination'
import type { ITFACurtailmentIntervalFilters, ITFACurtailmentIntervalRatioFilters } from '@/types/cpm/filters'
import type { IProgramAgreement, IProgramSuccessFilters, IProgramSuccessResponse } from '@/types/cpm/programSuccess'

export const getTFACurtailmentIntervals = async (
  filters: ITFACurtailmentIntervalFilters
): Promise<IPage<TFACurtailmentInterval>> => {
  const response = await axios.get(import.meta.env.VITE_APP_CPM_TFA_CURTAILMENT_INTERVALS_ENDPOINT, {
    params: filters,
  })
  return response.data
}

export const createTFACurtailmentInterval = async (
  payload: ITFACurtailmentIntervalCreationPayload
): Promise<TFACurtailmentInterval[]> => {
  const response = await axios.post(import.meta.env.VITE_APP_CPM_TFA_CURTAILMENT_INTERVALS_ENDPOINT, payload)
  return response.data
}

export const updateTFACurtailmentInterval = async (id: number, curtailed: boolean): Promise<TFACurtailmentInterval> => {
  const response = await axios.patch(`${import.meta.env.VITE_APP_CPM_TFA_CURTAILMENT_INTERVALS_ENDPOINT}/${id}`, {
    curtailed,
  })
  return response.data
}

export const deleteTFACurtailmentInterval = async (id: number): Promise<void> => {
  await axios.delete(`${import.meta.env.VITE_APP_CPM_TFA_CURTAILMENT_INTERVALS_ENDPOINT}/${id}`)
}

export const getTFACurtailmentIntervalsRatio = async (
  filters: ITFACurtailmentIntervalRatioFilters
): Promise<ICurtailmentRatio> => {
  const response = await axios.get(
    `${import.meta.env.VITE_APP_CPM_TFA_CURTAILMENT_INTERVALS_ENDPOINT}/curtailment-ratio`,
    {
      params: filters,
    }
  )
  return response.data
}

export const getTFAProgramSuccess = async (filters: IProgramSuccessFilters): Promise<IProgramSuccessResponse> => {
  const response = await axios.get(import.meta.env.VITE_APP_CPM_TFA_PROGRAM_SUCCESS_ENDPOINT, {
    params: filters,
  })
  return response.data
}

const cpmAgreementEndpoint = (siteId: string) => `${import.meta.env.VITE_APP_CPM_SITES_ENDPOINT}/${siteId}/agreement`

/** Upload or replace the site's CPM program agreement PDF (one per site). */
export const uploadCPMAgreement = async (siteId: string, document: File, name?: string): Promise<IProgramAgreement> => {
  const formData = new FormData()
  formData.append('document', document)
  if (name) formData.append('name', name)

  const response = await axios.post(cpmAgreementEndpoint(siteId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

/** Remove the site's CPM program agreement PDF. */
export const deleteCPMAgreement = async (siteId: string): Promise<void> => {
  await axios.delete(cpmAgreementEndpoint(siteId))
}
